module.exports = __webpack_public_path__ + "static/media/tp.e43b0ca3.svg";